import { useState } from "react";
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { TicketHistoryList } from "./ticket-historyList";

export function TicketHistoryPanel() {

    const [isLoading, setIsLoading] = useState(false);


    return (
        <>
            <StandardPanel
                title="History"
                loading={isLoading}>

                <TicketHistoryList />
            </StandardPanel>
        </>
    );

}
